// 2024(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import TomSelect from "tom-select/dist/js/tom-select.popular.js";

const resetfield_handler = function(e) {

    // Clear field class
    e.target.classList.remove('is-valid');
    e.target.classList.remove('is-invalid');

    // Clear label class
    document.querySelectorAll(['label[for=' + e.target.id + ']']).forEach(el => {
        el.classList.remove('text-success');
        el.classList.remove('text-danger');
    });

    // Clear errors
    document.querySelectorAll('.errorlist').forEach(el => {
        if (el.dataset.target === e.target.id) {
            el.remove();
        }
    });

    e.target.removeEventListener("change", resetfield_handler);
};

export function init() {

    // Reset validation on fields when changed
    document.querySelectorAll('.form-control.is-valid, .form-control.is-invalid, .form-select.is-valid, .form-select.is-invalid').forEach(el => {
        el.addEventListener("change", resetfield_handler);
    });
    
    // TOM-Select
    window.TomSelect = TomSelect;

    document.querySelectorAll('.form-select-multi,.form-tomselect').forEach(el => {
        new TomSelect(el, {
            allowEmptyOption: true
        });
    });
}